import { TranscriptionIllustrationLayout } from "../TranscriptionIllustrationLayout";

import {
  PickMessageProps,
  TranscriptMessageProps,
} from "./TranscriptionEmptyMessage.decl";
import { TranscriptionBadAccoustics } from "./components/TranscriptionBadAccoustics";
import { TranscriptionLowConfidence } from "./components/TranscriptionLowConfidence";
import { TranscriptionNoSpeechDetected } from "./components/TranscriptionNoSpeechDetected";

function PickMessage({ value }: PickMessageProps) {
  switch (value) {
    case "badAcoustics":
      return <TranscriptionBadAccoustics />;
    case "lowConfidence":
      return <TranscriptionLowConfidence />;
    case "noSpeechDetected":
      return <TranscriptionNoSpeechDetected />;
    default:
      return null;
  }
}

export function TranscriptionMessage({ status }: TranscriptMessageProps) {
  if (!status || status === "available") {
    return null;
  }

  return (
    <TranscriptionIllustrationLayout data-test={status}>
      <PickMessage value={status} />
    </TranscriptionIllustrationLayout>
  );
}
